import script from "./CgvClient.vue?vue&type=script&setup=true&lang=js"
export * from "./CgvClient.vue?vue&type=script&setup=true&lang=js"

import "./CgvClient.vue?vue&type=style&index=0&id=65499c7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65499c7a"]])

export default __exports__